import React from 'react'
import { Helmet } from 'react-helmet';

const PrivacyPolicy = () => {
    return (
        <div>
            <Helmet>
                <title>Privacy Policy </title>
            </Helmet>
            <div className="main-container">
                <div className="section">
                    <div className="page-heading">
                        <h1>  Privacy Policy</h1>
                    </div>
                    <div className="para-content">
                        <p>At Sports IIT Gandhinagar Website, we value the privacy of our users and understand the importance of protecting your personal information. This privacy policy outlines the ways in which we collect, use, and protect your information when you use our website.</p> </div>

                        <div className="para-content">
                        <p>Information Collection and Use: We collect personal information from our website visitors when they fill out a form, or register for an event. The personal information that we may collect includes your name, email address, and phone number. We use this information to send you updates and information about the event, including event invitations, and other relevant information. We may also use this information to contact you directly.</p> </div>

                        <div className="para-content">
                        <p>Information security:
                        We take appropriate measures to protect your personal information from unauthorized access, disclosure, or alteration.</p> </div>

                        <div className="para-content">
                        <p>Updates to this policy:
                        We may update this privacy policy from time to time to reflect changes in our practices or to comply with legal requirements. Any updates to this policy will be posted on our website, and we encourage you to review this policy periodically.</p> </div>

                        <div className="para-content">
                        <p>Contact us:
                        If you have any questions or concerns, please contact us at sports@iitgn.ac.in.</p> </div>

                    

                    


                        

                        


                </div>

            </div>


        </div>
    )
}

export default PrivacyPolicy